/* eslint-disable import/no-mutable-exports */
var tooltip = {
    init: function () {
         // $('[data-toggle="tooltip"]').tooltip();
    }
};
export default tooltip;